import React, { Component } from 'react';
import { Translation } from 'react-i18next';

function Ans2() {
  return (
    <Translation>
      {(t) => (
        <div className="bg">
          <ol className="ans">
            <li>
              <b className="fisrt-line">{t('ans_2.text_1')}</b>
              <p>{t('ans_2.text_2')}</p>
              <div style={{ paddingBottom: '16px', marginLeft: '20px' }}>
                <span>{t('ans_2.text_3')}</span>
                <a href="https://apps.apple.com/app/id1462406645" className="link" target="_blank" rel="noreferrer"> https://apps.apple.com/app/id1462406645</a>
                <br />
                <span>{t('ans_2.text_4')}</span>
                <a href="https://apps.apple.com/app/id1462406645" className="link" target="_blank" rel="noreferrer"> https://play.google.com/store/apps/details?id=com.trustkeysnetwork</a>
              </div>
              <p>{t('ans_2.text_5')}</p>
            </li>
            <li>
              <b>{t('ans_2.text_6')}</b>
              <p>{t('ans_2.text_7')}</p>
            </li>
            <li>
              <b>{t('ans_2.text_8')}</b>
              <p>
                <div>{t('ans_2.text_9')}</div>
                <div>{t('ans_2.text_10')}</div>
              </p>
            </li>
          </ol>
        </div>
      )}
    </Translation>
  );
}

export default Ans2;
